'use client';

/**
 * Vue dédiée : une seule section rendue à la fois (modèle index3CORANNDIAMSYL.html / showSection).
 * La navigation (Header / Hub / Footer) change `section` dans le store.
 */
import { useEffect } from 'react';
import { useApp, initBookmarks } from '@/lib/store';
import { DICTS, RTL_LANGS } from '@/lib/i18n';
import Header from '@/components/quran/Header';
import Hero from '@/components/quran/Hero';
import ReadPage from '@/components/quran/ReadPage';
import AcademySection from '@/components/quran/AcademySection';
import LearnSection from '@/components/quran/LearnSection';
import WriteSection from '@/components/quran/WriteSection';
import QiblaSection from '@/components/quran/QiblaSection';
import HijriSection from '@/components/quran/HijriSection';
import NamesSection from '@/components/quran/NamesSection';
import VideosSection from '@/components/quran/VideosSection';
import ToolsSection from '@/components/quran/ToolsSection';
import UniversSection from '@/components/quran/UniversSection';
import SciencesSection from '@/components/quran/SciencesSection';
import MiraclesSection from '@/components/quran/MiraclesSection';
import ConferenceSection from '@/components/quran/ConferenceSection';
import EspaceSection from '@/components/quran/EspaceSection';
import Footer from '@/components/quran/Footer';

export default function Home() {
  const uiLang = useApp((s) => s.uiLang);
  const section = useApp((s) => s.section);
  const dir = RTL_LANGS.includes(uiLang) ? 'rtl' : 'ltr';

  // PAGE FUSIONNÉE READ : THE BOOK + READ + LISTEN + 114 SURATS sur une même page
  const mergedAnchor: 'book' | 'read' | 'listen' | 'surahs' | null =
    section === 'livre' ? 'book'
    : section === 'sourates' ? 'surahs'
    : section === 'listen' ? 'listen'
    : section === 'read' ? 'read'
    : null;

  useEffect(() => {
    initBookmarks();
  }, []);

  return (
    <div dir={dir} lang={uiLang} className="flex min-h-screen flex-col bg-background text-foreground">
      <Header />
      <main className="flex-1">
        {section === 'home' && <Hero />}
        {mergedAnchor && <ReadPage anchor={mergedAnchor} />}
        {section === 'academy' && <AcademySection />}
        {section === 'learn' && <LearnSection />}
        {section === 'write' && <WriteSection />}
        {section === 'qibla' && <QiblaSection />}
        {section === 'hijri' && <HijriSection />}
        {section === 'names' && <NamesSection />}
        {section === 'videos' && <VideosSection />}
        {section === 'tools' && <ToolsSection />}
        {(section === 'gallery' || section === 'univers') && <UniversSection />}
        {section === 'sciences' && <SciencesSection />}
        {section === 'miracles' && <MiraclesSection />}
        {section === 'conference' && <ConferenceSection />}
        {section === 'espace' && <EspaceSection />}
      </main>
      <Footer />
    </div>
  );
}
